<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Devices</a></li>
          <li><a>Params</a></li>
        </ul>
      </div>
      <div class="block">
        <div class="page-header">
          <span class="page-header__title">Device Parameters</span>
          <img src="assets/images/New_Icons/refresh-icon.svg" alt="Refresh" title="Refresh" class="page-header__icon" width="17" height="17" (click)="!enableDisablePageLoader ? ngOnInit() : null"/>
        </div>
        <div class="list_block">
          <div class="toolbar">
            <div class="toolbar__search">
              <img src="../../../../../../assets/images/New_Icons/search-icon.svg">
              <input type="text" (ngModelChange)="onSearchChanged()" [(ngModel)]="search" name="search" autocomplete="off" placeholder="Search by device serial number, parameter"/>
            </div>
            <div class="toolbar__spacer"></div>
            <div class="toolbar__add-button" (click)="openForm()">
              <button type="button">
                <span class="toolbar__add-icon">
                  <img src="../../../../../../assets/images/New_Icons/plus-icon.svg" alt="Add Icon"/>
                </span>
                <span class="toolbar__add-text">Add New</span>
              </button>
            </div>
          </div>
        </div>

        <div *ngIf="enableDisablePageLoader">
          <div class="adjust">
            <div class="loader2"></div>
          </div>
        </div>

        <div class="cards_container" *ngIf="!enableDisablePageLoader">
          <div class="card_wrapper" *ngFor="let item of paginatedDeviceParametersList; let i = index">
            <div class="master-card">
              <div class="master-card-header">
                <div class="master-card-title">
                  <img src="../../../../../../assets/images/New_Icons/card-heading.svg">
                  <span>{{ item?.deviceNumber }}</span>
                </div>
              </div>
              <div class="master-card-body">
                <div class="master-card-body-info flex-wrap-info">
                  <span *ngFor="let p of item.params" class="badge-tag margin-right-5 mb-5">
                    {{ p?.qpName }}
                  </span>
                </div>
              </div>
              <div class="master-card-footer">
                <div class="master-card-footer-info">
                  <span class="label">Total Parameters:</span>
                  <span class="text">{{ item?.params?.length || 0 }}</span>
                </div>
                <div class="action-icons">
                  <a>
                    <img src="../../../../../../assets/images/New_Icons/edit.svg" title="Edit Device Parameters" (click)="getDeviceParamByNumber(item.deviceNumber)">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="listLoader" class="loader-div">
          <div class="adjust">
            <div class="loader2 list-loader"></div>
          </div>
        </div>
        <div *ngIf="noList && !enableDisablePageLoader" class="noDataFoundMessage">Device Parameters Not Found</div>
      </div>

      <!-- Add/Update Form Drawer -->
      <div class="dynamic-form-wrapper slide-in-overlay" *ngIf="showForm">
        <div class="popup-wrapper">
          <button type="button" class="popup-close-beside" (click)="clear()" title="Close">&times;</button>
          <div class="form-container-panel">
            <form [formGroup]="registerForm" novalidate>
              <div class="form-header">
                <div class="form-title">Device Parameter</div>
                <button class="add-update-submit-button" (click)="addUpdateDeviceParam()" [disabled]="deviceParametersDoubleClick">
                  <span class="icon"><img src="../../../../../../assets/images/New_Icons/tick-icon.svg"></span>
                  <span class="text">{{ submitButton ? 'Submit' : 'Update' }}</span>
                </button>
              </div>
              <div class="form-container">
                <!-- Device Serial Number -->
                <mat-form-field appearance="outline" class="w-100" *ngIf="submitButton">
                  <mat-label>Device Serial No.</mat-label>
                  <mat-select formControlName="device_id">
                    <mat-option value="" disabled>Select Device Serial No.</mat-option>
                    <mat-option *ngFor="let dev of unassignedDevices" [value]="dev.id">{{ dev.number }}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="(registerForm.controls.device_id.touched || submitted) && registerForm.controls.device_id.hasError('required')">
                    <i>Device serial number is required.</i>
                  </mat-error>
                </mat-form-field>

                <div class="form-group-read-only mb-15" *ngIf="updateButton">
                  <label class="mat-label-read-only">Device Serial No.</label>
                  <div class="read-only-value">{{ selectedDeviceNumber }}</div>
                </div>

                <!-- Query Params Checkbox List -->
                <div class="qp-checkbox-section margin-top-15">
                  <label class="qp-section-label mb-10">Query Parameters</label>
                  <div class="row">
                    <div class="col-xs-6 mb-10" *ngFor="let qp of allqpdata">
                      <mat-checkbox [(ngModel)]="qp.isAvailable" [ngModelOptions]="{standalone: true}">
                        {{ qp?.name }}
                      </mat-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
